import React from "react";

interface DocumentIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string; // Optional global fill override
}

const DocumentIcon: React.FC<DocumentIconProps> = ({
  width = 16,
  height = 16,
  fill = "white",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M11.7155 16H4.28659C3.02601 16 2 14.9667 2 13.6966V2.30747C2 1.03538 3.02601 0 4.28659 0H7.35441C7.87251 0 8.36614 0.113212 8.81897 0.337579C9.16573 0.491959 9.49617 0.724559 9.78786 1.01891L12.9903 4.24444C13.2759 4.53261 13.5064 4.86607 13.6757 5.23865C13.8878 5.68738 14 6.19375 14 6.70217V13.6925C14 14.9646 12.974 16 11.7134 16H11.7155ZM4.28659 1.0292C3.58695 1.0292 3.01989 1.6035 3.01989 2.30747V13.6966C3.01989 14.3986 3.58899 14.9708 4.28659 14.9708H11.7134C12.4131 14.9708 12.9801 14.3965 12.9801 13.6925V6.70217C12.9801 6.34607 12.9006 5.99202 12.7517 5.67503C12.6313 5.41361 12.4661 5.17278 12.2682 4.97311L9.06578 1.74759C8.8618 1.54175 8.63335 1.38119 8.38654 1.27004C8.05609 1.10742 7.71545 1.0292 7.35237 1.0292H4.28455H4.28659Z"
        fill={fill}
      />
      <path
        d="M13.2147 5.96961H8.59667C8.31518 5.96961 8.08673 5.73907 8.08673 5.45501V0.798892C8.08673 0.623928 8.17444 0.461314 8.31926 0.366627C8.46409 0.27194 8.64767 0.257531 8.80473 0.327517C9.16577 0.490131 9.49621 0.722731 9.78994 1.01708L12.9924 4.24467C13.278 4.53284 13.5085 4.86631 13.6778 5.23682C13.7512 5.39532 13.7389 5.58263 13.6451 5.73084C13.5513 5.87904 13.3901 5.96755 13.2147 5.96755V5.96961ZM9.10662 4.94041H12.2377L9.10662 1.78693V4.94041Z"
        fill={fill}
      />
      <path
        d="M9.02099 9.05069H5.71044C5.42895 9.05069 5.2005 8.82015 5.2005 8.53609C5.2005 8.25203 5.42895 8.02148 5.71044 8.02148H9.02099C9.30248 8.02148 9.53094 8.25203 9.53094 8.53609C9.53094 8.82015 9.30248 9.05069 9.02099 9.05069Z"
        fill={fill}
      />
      <path
        d="M10.2918 12.1342H5.71044C5.42895 12.1342 5.2005 11.9036 5.2005 11.6196C5.2005 11.3355 5.42895 11.105 5.71044 11.105H10.2918C10.5733 11.105 10.8017 11.3355 10.8017 11.6196C10.8017 11.9036 10.5733 12.1342 10.2918 12.1342Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_1915_7721">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DocumentIcon;
